import React, { useEffect } from "react";
import "./DeleteAccountModal.css";

const DeleteAccountModal = ({ show, onClose, onConfirm }) => {
  useEffect(() => {
    if (!show) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <div className="delete-account-backdrop" onClick={onClose}>
      <div
        className="delete-account-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-account-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="delete-account-header">
          <h2 id="delete-account-modal-title">Delete Account</h2>
          <button
            type="button"
            className="delete-account-close"
            aria-label="Close delete account modal"
            onClick={onClose}
          >
            <i className="ph ph-x" />
          </button>
        </div>

        <div className="delete-account-body">
          <span className="delete-account-warning-icon" aria-hidden="true">
            !
          </span>

          <h3>Delete Account</h3>
          <p>Are you sure you want to delete account?</p>

          <div className="delete-account-actions">
            <button
              type="button"
              className="delete-account-no"
              onClick={onClose}
            >
              No
            </button>
            <button
              type="button"
              className="delete-account-yes"
              onClick={handleConfirm}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
